import {
  KEY_PRESSED,
} from "./actions";
import { TTrainerActions } from "./actions";

type TTrainerState = {
  trainString: string;
  trainStringCharStatus: number[];
  cursorIndex: number;
  typingSpeed?: number;
  accuracy?: number;
  errorRate?: number;
};

const initialState = {
  trainString: "",
  trainStringCharStatus: [0],
  cursorIndex: 0,
  typingSpeed: 0,
  accuracy: 0,
  errorRate: 0
};

export const reducer = (state = initialState, action: TTrainerActions): TTrainerState => {
  switch (action.type) {
    case KEY_PRESSED:
      const validKeys = /^[a-zA-Z0-9 .,?!'";:\-]$/;
      
      if (!validKeys.test(action.payload) && action.payload !== 'Backspace') {
        return state;
      }

      let cursorIndex = state.cursorIndex;
      const nextTrainStringCharStatus = [...state.trainStringCharStatus];

      if (action.payload === 'Backspace') {
        if (state.cursorIndex > 0) {
          cursorIndex -= 1;
          nextTrainStringCharStatus[cursorIndex] = 0;
        }
      } else {
        if (state.cursorIndex < state.trainString.length) {
          if (action.payload === state.trainString[state.cursorIndex]) {
            nextTrainStringCharStatus[state.cursorIndex] = 1;
          } else {
            nextTrainStringCharStatus[state.cursorIndex] = -1;
          }

          cursorIndex += 1;
        }
      }

      return {
        ...state,
        trainStringCharStatus: nextTrainStringCharStatus,
        cursorIndex: cursorIndex
      }

    case "UPDATE_STRING":
      if (action.payload.message_type == "MessageTextUpdate") {
        return {
          ...state,
          trainString: action.payload.text,
          trainStringCharStatus: Array(action.payload.text.length).fill(0),
          cursorIndex: 0
        };
      } else if (action.payload.message_type == "MessageStatisticsUpdate") {
        return {
          ...state,
          typingSpeed: action.payload.typing_speed,
          accuracy: action.payload.accuracy,
          errorRate: action.payload.error_rate
        }
      }

      return state;

    default:
      return state;
  }
};
